import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Icon from 'public/feature1.svg';
import Arrow from 'public/show-arrow.svg';
import { Card, IconWrapper, P, ShopNow, ShopNowArrow } from './GuaranteeCard.styled';
type Props = {};

export default function GuaranteeCard({}: Props) {
  const { t, lang } = useTranslation('Product');
  return (
    <Card>
      <IconWrapper>
        <Image src={Icon} width={60} height={60} alt="guaranty icon" />
      </IconWrapper>
      <P>{t('guarantee_card')}</P>
      <ShopNow href="/products">
        {t('shop_now')}
        <ShopNowArrow>
          <Image src={Arrow} width={7.4} height={12} alt="shop now arrow" />
        </ShopNowArrow>
      </ShopNow>
    </Card>
  );
}
